import PropTypes from 'prop-types';

import { ImageAsset, ImageContainer } from './Image.styles';

export const Image = ({ alt, src }) => (
  <ImageContainer aria-label="image container">
    <ImageAsset width={500} alt={alt} src={src} />
  </ImageContainer>
);

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired
};
